import React from "react";
import Table from "../../../components/Table";
import { CategoryTrend } from "../../../services/seo-report";

// Define the structure for a table row
interface TableRow {
  category: string;
  traffic_change?: string;
  [key: `${string}_leads`]: number;
  [key: `${string}_traffic`]: number;
}

const CategoryTrendTable: React.FC<{
  categoryTrendData: Record<string, CategoryTrend>;
}> = ({ categoryTrendData }) => {
  const months = Object.keys(categoryTrendData).filter(
    (key) => key !== "traffic_change",
  );

  // Get the last month from the list of months
  const lastMonth = months[months.length - 1];

  const columns = [
    { key: "category", header: "Category", width: "150px" },
    ...months.flatMap((month) => [
      { key: `${month}_leads`, header: `${month} Leads`, width: "100px" },
      { key: `${month}_traffic`, header: `${month} Traffic`, width: "100px" },
    ]),
    { key: "traffic_change", header: "Traffic change(%)", width: "150px" },
  ];

  // Get categories from the first month's data
  const firstMonth = months[0];
  const categories = firstMonth
    ? Object.keys(categoryTrendData[firstMonth].leads)
    : [];

  const data = categories.map((category): TableRow => {
    const row: TableRow = {
      category,
      // traffic_change is optional in the CategoryTrend interface
      traffic_change: categoryTrendData[firstMonth]?.traffic_change?.[category],
    };

    months.forEach((month) => {
      const monthData = categoryTrendData[month];
      row[`${month}_leads` as const] = monthData.leads[category] || 0;
      row[`${month}_traffic` as const] = monthData.traffic[category] || 0;
    });

    return row;
  });

  return (
    <Table
      data={data}
      columns={columns}
      noMaxHeight={true}
      compact={true}
      sortBy={`${lastMonth}_leads`}
      alternateRowColor={true}
    />
  );
};

export default CategoryTrendTable;
